import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Table } from 'reactstrap';

class RoundedTable extends Component {

  static propTypes = {
    className: PropTypes.string,
    striped: PropTypes.bool,
    hover: PropTypes.bool,
    responsive: PropTypes.bool
    // xPadding: PropTypes.number,
    // yPadding: PropTypes.number,
  }

  static defaultProps = {
    className: '',
    striped: false,
    hover: false,
    responsive: true
    // xPadding: 20,
    // yPadding: 20,
  }

  render() {
    const {
      className,
      striped,
      hover,
      children,
      responsive
    } = this.props;

    return (
      <Table
        className={`RoundedTable--root ${className}`}
        striped={striped}
        hover={hover}
        responsive={responsive}
      >
        {children}
      </Table>
    );
  }
}

export default RoundedTable;



// WEBPACK FOOTER //
// ./src/shared/components/RoundedTable/RoundedTable.js